module.exports = __webpack_public_path__ + "static/media/wrecker_gray.109c0b06.svg";